import apiClient from './apiClient';
import { ApiResponse, PaginatedResponse } from '../../types/common';
import { PhoneReport, ReportFilters, VictimProfile, VictimStats } from '../../types/report';

export const getPhoneReports = async (
  filters: ReportFilters
): Promise<PaginatedResponse<PhoneReport>> => {
  const response = await apiClient.get<ApiResponse<PaginatedResponse<PhoneReport>>>(
    '/admin/reports/phone',
    { params: filters }
  );

  if (response.data.status !== 200 || !response.data.data) {
    throw new Error(response.data.message || '?�고 목록 조회???�패?�습?�다.');
  }

  return response.data.data;
};

export const approvePhoneReport = async (id: string, displayLabel?: string): Promise<PhoneReport> => {
  const response = await apiClient.put<ApiResponse<PhoneReport>>(
    `/admin/reports/phone/${id}/approve`,
    { displayLabel }
  );

  if (response.data.status !== 200 || !response.data.data) {
    throw new Error(response.data.message || '신고 승인에 실패했습니다.');
  }

  return response.data.data;
};

export const rejectPhoneReport = async (id: string, reason?: string): Promise<PhoneReport> => {
  const response = await apiClient.put<ApiResponse<PhoneReport>>(
    `/admin/reports/phone/${id}/reject`,
    { reason }
  );

  if (response.data.status !== 200 || !response.data.data) {
    throw new Error(response.data.message || '신고 거부에 실패했습니다.');
  }

  return response.data.data;
};

export const updatePhoneReport = async (
  id: string,
  data: Partial<PhoneReport>
): Promise<PhoneReport> => {
  const response = await apiClient.put<ApiResponse<PhoneReport>>(
    `/admin/reports/phone/${id}`,
    data
  );

  if (response.data.status !== 200 || !response.data.data) {
    throw new Error(response.data.message || '신고 수정에 실패했습니다.');
  }

  return response.data.data;
};

export const deletePhoneReport = async (id: string): Promise<void> => {
  const response = await apiClient.delete<ApiResponse<void>>(
    `/admin/reports/phone/${id}`
  );

  if (response.data.status !== 200) {
    throw new Error(response.data.message || '신고 삭제에 실패했습니다.');
  }
};

export const getVictimReports = async (
  filters: Partial<ReportFilters>
): Promise<PaginatedResponse<VictimProfile>> => {
  const response = await apiClient.get<ApiResponse<PaginatedResponse<VictimProfile>>>(
    '/admin/reports/victim',
    { params: filters }
  );

  if (response.data.status !== 200 || !response.data.data) {
    throw new Error(response.data.message || '?�해 ?�고 목록 조회???�패?�습?�다.');
  }

  return response.data.data;
};

export const getVictimStats = async (): Promise<VictimStats> => {
  const response = await apiClient.get<ApiResponse<VictimStats>>('/admin/reports/victim/stats');

  if (response.data.status !== 200 || !response.data.data) {
    throw new Error(response.data.message || '?�해 ?�계 조회???�패?�습?�다.');
  }

  return response.data.data;
};
